import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';
import { ManagerContext } from '../../contexts/ManagerContext';
import SimpleSnackbar from './SnackbarInfo';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import SendIcon from '@mui/icons-material/Send';




export default function ResetPasswordDialog( { messageType=0, btVisible=true, _open=false } ) {
  const [ open, setOpen ] = React.useState(false);
  // const [ btVisible, setBtVisible ] = React.useState(true);


  const { sendAuth, setOpenSnack } = React.useContext(ManagerContext);
  const [ message, setMessage ] = React.useState('');

  const [ email, setEmail ] = React.useState('');
  const [ waitResponse, setWaitResponse ] = React.useState(false);
  const vertical = 'top';
  const horizontal = 'center';
  const [ error, setError ] = React.useState('');

  React.useEffect(() => {
    setOpen(_open)
  }, [_open])

  React.useEffect(() => {
    if(messageType===0){
      const newMessage = 'Jeżeli podany email istnieje w naszej bazie zostanie na niego wysłany email z linkiem do zmiany hasła.'
      setMessage(newMessage);
    }else
    if (messageType===1){
      const newMessage = 'Token wygasł! Czy wysłać ponownie email z nowym linkiem do zmiany hasła?'
      setMessage(newMessage);
    }
  }, [messageType]);


  const sendTask = async (datas) => {
    const map = new Map();
    map.set("data", datas.data );
    map.set("task", datas.task );
    setWaitResponse(true)
    const response = await sendAuth(map);
    setWaitResponse(false)
    console.log('response', response);
    if (response.send_email_reset_status && response.send_email_reset_status === 1){
      setOpenSnack('email send')
      handleClose()
    }else{
      setEmail('')
      setError('email nie istnieje')
    }

}
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      
    <React.Fragment>
      {btVisible && <Button color= 'white' onClick={handleClickOpen}>
      Forgot your password?
      </Button>}
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{ zIndex: 1302 }}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle>Reset Password</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            label="Email Address"
            type="email"
            value={email}
            fullWidth
            variant="standard"
            error={!!error}
            helperText={error}
            onChange={e => {setEmail(e.target.value); setError('')}}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <LoadingButton 
            endIcon={<SendIcon />}
            // variant="contained"
            onClick={() => {
              const data = { email: email }
              const datas = { task: 'send_email_reset', data: data }
              sendTask(datas);}}
            loading={waitResponse} type="submit">
              Send
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    </div>
  );
}